<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_SalesReport001
 * @created at      :   2025/09/26
 * @created by      :   ANS901 – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapMutations, mapState, mapActions } from 'vuex';
import store from '@/store';
import APP_SalesReport001_store from '@/views/mobile/app_sales_report/APP_SalesReport001/store';
import AnsPanel from '@/components/ansPanel/index.vue';
import APP_SalesReport002 from '@/views/mobile/app_sales_report/APP_SalesReport002';
import PopupMST001 from '@/views/popupSearch/PopupMST001/store';
import PopupMST002 from '@/views/popupSearch/PopupMST002/store';
import PopupMST008 from '@/views/popupSearch/PopupMST008/store';
import PopupMST005 from '@/views/popupSearch/PopupMST005/store';
import PopupSystem001 from '@/views/popupSearch/PopupSystem001/store';
import template from './template.html';
import './style.scss';
import helpers from '@/utils/helpers';
import { MSG_TYPE, MSG_TITLE } from '@/utils/messages';

var APP_SalesReport001 = {
    template: template,
    components: {
        AnsPanel,
        APP_SalesReport002
    },
    beforeCreate() {
        if (!store.hasModule('APP_SalesReport001')) {
            store.registerModule('APP_SalesReport001', APP_SalesReport001_store);
        }
        if (!store.hasModule('PopupMST001')) {
            store.registerModule('PopupMST001', PopupMST001);
        }
        if (!store.hasModule('PopupMST002')) {
            store.registerModule('PopupMST002', PopupMST002);
        }
        if (!store.hasModule('PopupMST008')) {
            store.registerModule('PopupMST008', PopupMST008);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005);
        }
        if (!store.hasModule('PopupSystem001')) {
            store.registerModule('PopupSystem001', PopupSystem001);
        }
    },
    async created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        this.resetDataInit();
        await this.applyLoginSearchDefault();
    },
    mounted() {
        this.setHeader(this.header);
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.setHeader();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'APP_SalesReport001',
            sort: {
                client_cd: '',
                branch_cd: '',
                trading_target_base_name: '',
                report_date: '',
                trading_target_responsible: '',
                sales_responsible: '',
                sales_considerations: ''
            },
            rowActive: null,
            showDetail: false,
            windowWidth: 0,
            type: 1,
            mode: 0,
            propsToSalesReport002: {
                mode: 0,
                company_cd: '',
                company_nm: '',
                client_cd: '',
                mdcd: 0,
                branch_cd: 0,
                branch_nm: ''
            }
        };
    },
    watch: {
        'data.company_cd'(newVal, oldVal) {
            if (String(newVal ?? '') === String(oldVal ?? '')) return;
            this.clearByCompanyChange();
        },
        'data.client_cd'(newVal, oldVal) {
            if (String(newVal ?? '') === String(oldVal ?? '')) return;
            this.clearByClientChange();
        }
    },
    computed: {
        ...mapState('app', ['user']),
        ...mapState('APP_SalesReport001', ['data', 'options', 'selectOptionKey', 'paginationData', 'searchData']),
        loginCompanyCd() {
            const companyCd = Number(this.user?.company_cd);
            return Number.isNaN(companyCd) ? null : companyCd;
        },
        isCompanyEditable() {
            return this.loginCompanyCd === null || this.loginCompanyCd === 99;
        },
        header() {
            return {
                title: '取引先別営業報告一覧',
                topButtons: []
            };
        },
        isMobile() {
            return helpers.checkIfMobile();
        },
        isIpad() {
            return !(this.windowWidth > 768 && this.windowWidth <= 1366);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapMutations('APP_SalesReport001', ['resetDataInit']),
        ...mapActions('APP_SalesReport001', ['actionSearch']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapActions('PopupMST001', ['searchMst001Info']),
        ...mapActions('PopupMST002', ['searchMst002Info']),
        ...mapActions('PopupMST008', ['searchMst008Info']),
        ...mapActions('PopupSystem001', ['searchSystemInfo']),
        clearByClientChange() {
            this.data.branch_cd = '';
            this.data.branch_nm = '';
            this.data.sales_rep_person_cd = '';
            this.data.sales_rep_person_nm = '';
        },
        clearByCompanyChange() {
            this.data.supervising_department = '';
            this.data.supervising_department_name = '';
            this.data.client_cd = '';
            this.data.client_nm = '';
            this.clearByClientChange();
        },
        async applyLoginSearchDefault() {
            const loginCompanyCd = this.user?.company_cd ?? '';
            const loginDepartmentCd = this.user?.department_cd ?? '';

            if (loginCompanyCd !== null && loginCompanyCd !== undefined && loginCompanyCd !== '') {
                this.data.company_cd = String(loginCompanyCd);
                await this.referCompany(0, this.data.company_cd);
            }

            if (loginDepartmentCd !== null && loginDepartmentCd !== undefined && loginDepartmentCd !== '') {
                await this.referAreaInfo(0, String(loginDepartmentCd));
            }
        },
        referCompany(index, value) {
            return new Promise((resolve) => {
                if (!value) {
                    this.data.company_cd = '';
                    this.data.company_name = '';
                    this.clearByCompanyChange();
                    resolve();
                    return;
                }

                this.searchSystemInfo({
                    company_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response?.Data?.data?.length > 0) {
                            const result = response.Data.data[0];
                            this.data.company_cd = result.company_cd;
                            this.data.company_name = result.company_name;
                        } else {
                            this.data.company_cd = '';
                            this.data.company_name = '';
                        }
                        this.clearByCompanyChange();
                        resolve();
                    }
                });
            });
        },
        getCompanyName(data) {
            this.data.company_name = data;
        },
        addSales() {
            this.openDetail();
        },
        referDetail() {
            this.showDetail = !this.showDetail;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        openDetail() {
            this.propsToSalesReport002 = {
                mode: 0,
                company_cd: '',
                company_nm: '',
                client_cd: '',
                mdcd: 0,
                branch_cd: 0,
                branch_nm: ''
            };
            this.mode = 0;
            this.rowActive = null;
            this.showDetail = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        openSalesReport002(item, index = null) {
            this.propsToSalesReport002 = {
                ...(item || {}),
                mode: 1,
                company_cd: item?.company_cd || this.data.company_cd || '',
                company_nm: item?.company_nm || '',
                client_cd: item?.client_cd || '',
                mdcd: item?.mdcd || this.data.supervising_department || 0,
                branch_cd: item?.branch_cd || 0,
                branch_nm: item?.branch_nm || ''
            };
            this.mode = 1;
            if (index !== null) this.rowActive = index;
            this.showDetail = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        referAreaInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    this.data.supervising_department = '';
                    this.data.supervising_department_name = '';
                    this.data.client_cd = '';
                    this.data.client_nm = '';
                    this.clearByClientChange();
                    resolve();
                    return;
                }
                this.searchAreaInfo({
                    company_cd: this.data.company_cd ?? this.user?.company_cd ?? 0,
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.data.supervising_department = result.department_cd;
                            this.data.supervising_department_name = result.department_name;
                        } else {
                            this.data.supervising_department = '';
                            this.data.supervising_department_name = '';
                            this.data.client_cd = '';
                            this.data.client_nm = '';
                            this.clearByClientChange();
                        }
                        resolve();
                    },
                    onError: (error) => reject(error)
                });
            });
        },
        getAreaName(data) {
            this.data.supervising_department_name = data;
        },
        referClientInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    this.data.client_cd = '';
                    this.data.client_nm = '';
                    this.clearByClientChange();
                    resolve();
                    return;
                }
                this.searchMst001Info({
                    company_cd: this.data.company_cd ?? this.user?.company_cd ?? '',
                    customer_cd: value || 0,
                    pageNo: 1,
                    pageSize: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.data.client_cd = result.customer_cd ?? '';
                            this.data.client_nm = result.customer_name ?? '';
                        } else {
                            this.data.client_cd = '';
                            this.data.client_nm = '';
                        }
                        this.clearByClientChange();
                        resolve();
                    },
                    onError: (error) => reject(error)
                });
            });
        },
        getClientName(data) {
            this.data.client_nm = data;
        },
        referSalesRepPersonInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    this.data.sales_rep_person_cd = '';
                    this.data.sales_rep_person_nm = '';
                    resolve();
                    return;
                }
                this.searchMst008Info({
                    company_cd: this.data.company_cd ?? this.user?.company_cd ?? '',
                    department_cd: this.data.supervising_department ?? '',
                    employee_cd: value || 0,
                    pageNo: 1,
                    pageSize: 1,
                    mode: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.data.sales_rep_person_cd = result.user_cd ?? '';
                            this.data.sales_rep_person_nm = result.user_name ?? '';
                        } else {
                            this.data.sales_rep_person_cd = '';
                            this.data.sales_rep_person_nm = '';
                        }
                        resolve();
                    },
                    onError: (error) => reject(error)
                });
            });
        },
        getSalesRepPersonName(data) {
            this.data.sales_rep_person_nm = data;
        },
        referBranchInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    this.data.branch_cd = '';
                    this.data.branch_nm = '';
                    resolve();
                    return;
                }
                this.searchMst002Info({
                    company_cd: this.data.company_cd ?? this.user?.company_cd ?? '',
                    customer_cd: this.data.client_cd ?? 0,
                    mdcd: this.data.supervising_department ?? 0,
                    location_cd: value || 0,
                    pageNo: 1,
                    pageSize: 1,
                    mode: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.data.branch_cd = result.kyoten_cd ?? result.location_cd ?? '';
                            this.data.branch_nm = result.kyoten_name ?? result.location_name ?? '';
                        } else {
                            this.data.branch_cd = '';
                            this.data.branch_nm = '';
                        }
                        resolve();
                    },
                    onError: (error) => reject(error)
                });
            });
        },
        getBranchName(data) {
            this.data.branch_nm = data;
        },
        buildSearchBody(pageNo, pageSize) {
            const currentSort = this.getCurrentSort();
            return {
                company_cd: this.data.company_cd || '',
                supervising_department: this.data.supervising_department || '',
                client_cd: this.data.client_cd || '',
                branch_cd: this.data.branch_cd || '',
                sales_rep_person_cd: this.data.sales_rep_person_cd || '',
                working_date_start: this.data.working_date_start || '',
                working_date_end: this.data.working_date_end || '',
                col: currentSort.col,
                sort: currentSort.sort,
                page_no: pageNo,
                page_size: pageSize
            };
        },
        search() {
            this.actionSearch({
                body: this.buildSearchBody(1, this.paginationData.pageSize || 10),
                callback: () => {
                    this.rowActive = null;
                },
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E001,
                        content: error?.Message || 'Search failed.',
                        okText: 'OK'
                    });
                }
            });
        },
        changeCurrentPage(data) {
            this.actionSearch({
                body: this.buildSearchBody(data.currentPage, data.perPage),
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E001,
                        content: error?.Message || 'Search failed.',
                        okText: 'OK'
                    });
                }
            });
        },
        initArrow(col, key) {
            this.sort = {
                client_cd: '',
                branch_cd: '',
                trading_target_base_name: '',
                report_date: '',
                trading_target_responsible: '',
                sales_responsible: '',
                sales_considerations: ''
            };
            this.sort[col] = key;
        },
        getCurrentSort() {
            const col = Object.keys(this.sort).find((k) => this.sort[k]);
            if (!col) {
                return { col: '', sort: '' };
            }
            return {
                col,
                sort: this.sort[col]
            };
        },
        sortCol(key, col) {
            this.initArrow(col, key);
            this.actionSearch({
                body: {
                    ...this.buildSearchBody(1, this.paginationData.pageSize || 10),
                    col,
                    sort: key
                },
                callback: () => {
                    this.rowActive = null;
                },
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E001,
                        content: error?.Message || 'Search failed.',
                        okText: 'OK'
                    });
                }
            });
        },
        checked() {}
    }
};
export default APP_SalesReport001;
</script>
